/* tslint:disable */
/* eslint-disable */
/**
 * P4m.Module.Auth.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type ApiErrorResponseWithMessage,
    ApiErrorResponseWithMessageFromJSON,
    ApiErrorResponseWithMessageToJSON,
} from '../models/ApiErrorResponseWithMessage';
import {
    type ClaimDto,
    ClaimDtoFromJSON,
    ClaimDtoToJSON,
} from '../models/ClaimDto';
import {
    type ClientAllClaimReadDto,
    ClientAllClaimReadDtoFromJSON,
    ClientAllClaimReadDtoToJSON,
} from '../models/ClientAllClaimReadDto';
import {
    type DataSourceLoadOptions,
    DataSourceLoadOptionsFromJSON,
    DataSourceLoadOptionsToJSON,
} from '../models/DataSourceLoadOptions';
import {
    type LoadResult,
    LoadResultFromJSON,
    LoadResultToJSON,
} from '../models/LoadResult';
import {
    type Participant,
    ParticipantFromJSON,
    ParticipantToJSON,
} from '../models/Participant';
import {
    type ParticipantCreateDto,
    ParticipantCreateDtoFromJSON,
    ParticipantCreateDtoToJSON,
} from '../models/ParticipantCreateDto';
import {
    type ParticipantReadDto,
    ParticipantReadDtoFromJSON,
    ParticipantReadDtoToJSON,
} from '../models/ParticipantReadDto';
import {
    type ParticipantUserCreateDto,
    ParticipantUserCreateDtoFromJSON,
    ParticipantUserCreateDtoToJSON,
} from '../models/ParticipantUserCreateDto';
import {
    type ParticipantUserReadDto,
    ParticipantUserReadDtoFromJSON,
    ParticipantUserReadDtoToJSON,
} from '../models/ParticipantUserReadDto';
import {
    type ParticipantUserUpdateDto,
    ParticipantUserUpdateDtoFromJSON,
    ParticipantUserUpdateDtoToJSON,
} from '../models/ParticipantUserUpdateDto';

export interface UiApiParticipantsAddPostRequest {
    participantCreateDto?: ParticipantCreateDto;
}

export interface UiApiParticipantsAttributeValueAttributeNameUserIdsGetRequest {
    attributeValue: string;
    attributeName: string;
}

export interface UiApiParticipantsByUserGetRequest {
    userId?: string;
}

export interface UiApiParticipantsDxPostRequest {
    dataSourceLoadOptions?: DataSourceLoadOptions;
}

export interface UiApiParticipantsGetByClaimsPostRequest {
    clientId: string;
    claimDto: Array<ClaimDto>;
}

export interface UiApiParticipantsGetParticipantsByClientDXPostRequest {
    client?: string;
    dataSourceLoadOptions?: DataSourceLoadOptions;
}

export interface UiApiParticipantsIdClaimsAddPostRequest {
    id: number;
    clientAllClaimReadDto: Array<ClientAllClaimReadDto>;
}

export interface UiApiParticipantsIdClaimsGetRequest {
    id: number;
}

export interface UiApiParticipantsIdClaimsRemoveDeleteRequest {
    id: number;
    clientAllClaimReadDto: Array<ClientAllClaimReadDto>;
}

export interface UiApiParticipantsIdDeleteRequest {
    id: number;
}

export interface UiApiParticipantsIdGetRequest {
    id: number;
}

export interface UiApiParticipantsIdPostRequest {
    id: number;
    participantCreateDto?: ParticipantCreateDto;
}

export interface UiApiParticipantsIdUsersAddPostRequest {
    id: number;
    participantUserCreateDto: Array<ParticipantUserCreateDto>;
}

export interface UiApiParticipantsIdUsersGetRequest {
    id: number;
}

export interface UiApiParticipantsIdUsersRemoveDeleteRequest {
    id: number;
    requestBody: Array<string>;
}

export interface UiApiParticipantsIdUsersUpdatePostRequest {
    id: number;
    participantUserUpdateDto: Array<ParticipantUserUpdateDto>;
}

/**
 * 
 */
export class UiApiParticipantsApi extends runtime.BaseAPI {

    /**
     * Creates request options for uiApiParticipantsAddPost without sending the request
     */
    async uiApiParticipantsAddPostRequestOpts(requestParameters: UiApiParticipantsAddPostRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';


        let urlPath = `/ui-api/participants/add`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ParticipantCreateDtoToJSON(requestParameters['participantCreateDto']),
        };
    }

    /**
     * Создать нового участника
     */
    async uiApiParticipantsAddPostRaw(requestParameters: UiApiParticipantsAddPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const requestOptions = await this.uiApiParticipantsAddPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Создать нового участника
     */
    async uiApiParticipantsAddPost(requestParameters: UiApiParticipantsAddPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.uiApiParticipantsAddPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for uiApiParticipantsAttributeValueAttributeNameUserIdsGet without sending the request
     */
    async uiApiParticipantsAttributeValueAttributeNameUserIdsGetRequestOpts(requestParameters: UiApiParticipantsAttributeValueAttributeNameUserIdsGetRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['attributeValue'] == null) {
            throw new runtime.RequiredError(
                'attributeValue',
                'Required parameter "attributeValue" was null or undefined when calling uiApiParticipantsAttributeValueAttributeNameUserIdsGet().'
            );
        }

        if (requestParameters['attributeName'] == null) {
            throw new runtime.RequiredError(
                'attributeName',
                'Required parameter "attributeName" was null or undefined when calling uiApiParticipantsAttributeValueAttributeNameUserIdsGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/ui-api/participants/{attributeValue}/{attributeName}/userIds`;
        urlPath = urlPath.replace('{attributeValue}', encodeURIComponent(String(requestParameters['attributeValue'])));
        urlPath = urlPath.replace('{attributeName}', encodeURIComponent(String(requestParameters['attributeName'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Получение id пользователей участников по данным атрибута
     */
    async uiApiParticipantsAttributeValueAttributeNameUserIdsGetRaw(requestParameters: UiApiParticipantsAttributeValueAttributeNameUserIdsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        const requestOptions = await this.uiApiParticipantsAttributeValueAttributeNameUserIdsGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Получение id пользователей участников по данным атрибута
     */
    async uiApiParticipantsAttributeValueAttributeNameUserIdsGet(requestParameters: UiApiParticipantsAttributeValueAttributeNameUserIdsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.uiApiParticipantsAttributeValueAttributeNameUserIdsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for uiApiParticipantsByUserGet without sending the request
     */
    async uiApiParticipantsByUserGetRequestOpts(requestParameters: UiApiParticipantsByUserGetRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/ui-api/participants/by-user`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Получение участников пользователя
     */
    async uiApiParticipantsByUserGetRaw(requestParameters: UiApiParticipantsByUserGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ParticipantReadDto>>> {
        const requestOptions = await this.uiApiParticipantsByUserGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ParticipantReadDtoFromJSON));
    }

    /**
     * Получение участников пользователя
     */
    async uiApiParticipantsByUserGet(requestParameters: UiApiParticipantsByUserGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ParticipantReadDto>> {
        const response = await this.uiApiParticipantsByUserGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for uiApiParticipantsDxPost without sending the request
     */
    async uiApiParticipantsDxPostRequestOpts(requestParameters: UiApiParticipantsDxPostRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';


        let urlPath = `/ui-api/participants/dx`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DataSourceLoadOptionsToJSON(requestParameters['dataSourceLoadOptions']),
        };
    }

    /**
     * Поля объекта \"участник\":  ```  {    id: string;    name: string;    description: string;  }  ```
     * Возвращает список всех участников
     */
    async uiApiParticipantsDxPostRaw(requestParameters: UiApiParticipantsDxPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LoadResult>> {
        const requestOptions = await this.uiApiParticipantsDxPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LoadResultFromJSON(jsonValue));
    }

    /**
     * Поля объекта \"участник\":  ```  {    id: string;    name: string;    description: string;  }  ```
     * Возвращает список всех участников
     */
    async uiApiParticipantsDxPost(requestParameters: UiApiParticipantsDxPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LoadResult> {
        const response = await this.uiApiParticipantsDxPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for uiApiParticipantsGetByClaimsPost without sending the request
     */
    async uiApiParticipantsGetByClaimsPostRequestOpts(requestParameters: UiApiParticipantsGetByClaimsPostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling uiApiParticipantsGetByClaimsPost().'
            );
        }

        if (requestParameters['claimDto'] == null) {
            throw new runtime.RequiredError(
                'claimDto',
                'Required parameter "claimDto" was null or undefined when calling uiApiParticipantsGetByClaimsPost().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['clientId'] != null) {
            queryParameters['clientId'] = requestParameters['clientId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';


        let urlPath = `/ui-api/participants/get-by-claims`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['claimDto']!.map(ClaimDtoToJSON),
        };
    }

    /**
     * Получение участников по клеймам
     */
    async uiApiParticipantsGetByClaimsPostRaw(requestParameters: UiApiParticipantsGetByClaimsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ParticipantReadDto>>> {
        const requestOptions = await this.uiApiParticipantsGetByClaimsPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ParticipantReadDtoFromJSON));
    }

    /**
     * Получение участников по клеймам
     */
    async uiApiParticipantsGetByClaimsPost(requestParameters: UiApiParticipantsGetByClaimsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ParticipantReadDto>> {
        const response = await this.uiApiParticipantsGetByClaimsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for uiApiParticipantsGetParticipantsByClientDXPost without sending the request
     */
    async uiApiParticipantsGetParticipantsByClientDXPostRequestOpts(requestParameters: UiApiParticipantsGetParticipantsByClientDXPostRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['client'] != null) {
            queryParameters['client'] = requestParameters['client'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';


        let urlPath = `/ui-api/participants/GetParticipantsByClientDX`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DataSourceLoadOptionsToJSON(requestParameters['dataSourceLoadOptions']),
        };
    }

    /**
     * Получение участников по клиенту
     */
    async uiApiParticipantsGetParticipantsByClientDXPostRaw(requestParameters: UiApiParticipantsGetParticipantsByClientDXPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LoadResult>> {
        const requestOptions = await this.uiApiParticipantsGetParticipantsByClientDXPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LoadResultFromJSON(jsonValue));
    }

    /**
     * Получение участников по клиенту
     */
    async uiApiParticipantsGetParticipantsByClientDXPost(requestParameters: UiApiParticipantsGetParticipantsByClientDXPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LoadResult> {
        const response = await this.uiApiParticipantsGetParticipantsByClientDXPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for uiApiParticipantsIdClaimsAddPost without sending the request
     */
    async uiApiParticipantsIdClaimsAddPostRequestOpts(requestParameters: UiApiParticipantsIdClaimsAddPostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling uiApiParticipantsIdClaimsAddPost().'
            );
        }

        if (requestParameters['clientAllClaimReadDto'] == null) {
            throw new runtime.RequiredError(
                'clientAllClaimReadDto',
                'Required parameter "clientAllClaimReadDto" was null or undefined when calling uiApiParticipantsIdClaimsAddPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';


        let urlPath = `/ui-api/participants/{id}/claims/add`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['clientAllClaimReadDto']!.map(ClientAllClaimReadDtoToJSON),
        };
    }

    /**
     * Добавление клеймов участника
     */
    async uiApiParticipantsIdClaimsAddPostRaw(requestParameters: UiApiParticipantsIdClaimsAddPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.uiApiParticipantsIdClaimsAddPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Добавление клеймов участника
     */
    async uiApiParticipantsIdClaimsAddPost(requestParameters: UiApiParticipantsIdClaimsAddPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.uiApiParticipantsIdClaimsAddPostRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for uiApiParticipantsIdClaimsGet without sending the request
     */
    async uiApiParticipantsIdClaimsGetRequestOpts(requestParameters: UiApiParticipantsIdClaimsGetRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling uiApiParticipantsIdClaimsGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/ui-api/participants/{id}/claims`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Получение клеймов участника
     */
    async uiApiParticipantsIdClaimsGetRaw(requestParameters: UiApiParticipantsIdClaimsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ClientAllClaimReadDto>>> {
        const requestOptions = await this.uiApiParticipantsIdClaimsGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ClientAllClaimReadDtoFromJSON));
    }

    /**
     * Получение клеймов участника
     */
    async uiApiParticipantsIdClaimsGet(requestParameters: UiApiParticipantsIdClaimsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ClientAllClaimReadDto>> {
        const response = await this.uiApiParticipantsIdClaimsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for uiApiParticipantsIdClaimsRemoveDelete without sending the request
     */
    async uiApiParticipantsIdClaimsRemoveDeleteRequestOpts(requestParameters: UiApiParticipantsIdClaimsRemoveDeleteRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling uiApiParticipantsIdClaimsRemoveDelete().'
            );
        }

        if (requestParameters['clientAllClaimReadDto'] == null) {
            throw new runtime.RequiredError(
                'clientAllClaimReadDto',
                'Required parameter "clientAllClaimReadDto" was null or undefined when calling uiApiParticipantsIdClaimsRemoveDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';


        let urlPath = `/ui-api/participants/{id}/claims/remove`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['clientAllClaimReadDto']!.map(ClientAllClaimReadDtoToJSON),
        };
    }

    /**
     * Удаление клеймов участника
     */
    async uiApiParticipantsIdClaimsRemoveDeleteRaw(requestParameters: UiApiParticipantsIdClaimsRemoveDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.uiApiParticipantsIdClaimsRemoveDeleteRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Удаление клеймов участника
     */
    async uiApiParticipantsIdClaimsRemoveDelete(requestParameters: UiApiParticipantsIdClaimsRemoveDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.uiApiParticipantsIdClaimsRemoveDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for uiApiParticipantsIdDelete without sending the request
     */
    async uiApiParticipantsIdDeleteRequestOpts(requestParameters: UiApiParticipantsIdDeleteRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling uiApiParticipantsIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/ui-api/participants/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Удаление участника
     */
    async uiApiParticipantsIdDeleteRaw(requestParameters: UiApiParticipantsIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.uiApiParticipantsIdDeleteRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Удаление участника
     */
    async uiApiParticipantsIdDelete(requestParameters: UiApiParticipantsIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.uiApiParticipantsIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for uiApiParticipantsIdGet without sending the request
     */
    async uiApiParticipantsIdGetRequestOpts(requestParameters: UiApiParticipantsIdGetRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling uiApiParticipantsIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/ui-api/participants/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Получить данные участника
     */
    async uiApiParticipantsIdGetRaw(requestParameters: UiApiParticipantsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Participant>> {
        const requestOptions = await this.uiApiParticipantsIdGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ParticipantFromJSON(jsonValue));
    }

    /**
     * Получить данные участника
     */
    async uiApiParticipantsIdGet(requestParameters: UiApiParticipantsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Participant> {
        const response = await this.uiApiParticipantsIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for uiApiParticipantsIdPost without sending the request
     */
    async uiApiParticipantsIdPostRequestOpts(requestParameters: UiApiParticipantsIdPostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling uiApiParticipantsIdPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';


        let urlPath = `/ui-api/participants/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ParticipantCreateDtoToJSON(requestParameters['participantCreateDto']),
        };
    }

    /**
     * Обновить данные участника
     */
    async uiApiParticipantsIdPostRaw(requestParameters: UiApiParticipantsIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.uiApiParticipantsIdPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Обновить данные участника
     */
    async uiApiParticipantsIdPost(requestParameters: UiApiParticipantsIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.uiApiParticipantsIdPostRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for uiApiParticipantsIdUsersAddPost without sending the request
     */
    async uiApiParticipantsIdUsersAddPostRequestOpts(requestParameters: UiApiParticipantsIdUsersAddPostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling uiApiParticipantsIdUsersAddPost().'
            );
        }

        if (requestParameters['participantUserCreateDto'] == null) {
            throw new runtime.RequiredError(
                'participantUserCreateDto',
                'Required parameter "participantUserCreateDto" was null or undefined when calling uiApiParticipantsIdUsersAddPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';


        let urlPath = `/ui-api/participants/{id}/users/add`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['participantUserCreateDto']!.map(ParticipantUserCreateDtoToJSON),
        };
    }

    /**
     * Добавление пользователей участника
     */
    async uiApiParticipantsIdUsersAddPostRaw(requestParameters: UiApiParticipantsIdUsersAddPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.uiApiParticipantsIdUsersAddPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Добавление пользователей участника
     */
    async uiApiParticipantsIdUsersAddPost(requestParameters: UiApiParticipantsIdUsersAddPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.uiApiParticipantsIdUsersAddPostRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for uiApiParticipantsIdUsersGet without sending the request
     */
    async uiApiParticipantsIdUsersGetRequestOpts(requestParameters: UiApiParticipantsIdUsersGetRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling uiApiParticipantsIdUsersGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/ui-api/participants/{id}/users`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Получение пользователей участника
     */
    async uiApiParticipantsIdUsersGetRaw(requestParameters: UiApiParticipantsIdUsersGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ParticipantUserReadDto>>> {
        const requestOptions = await this.uiApiParticipantsIdUsersGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ParticipantUserReadDtoFromJSON));
    }

    /**
     * Получение пользователей участника
     */
    async uiApiParticipantsIdUsersGet(requestParameters: UiApiParticipantsIdUsersGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ParticipantUserReadDto>> {
        const response = await this.uiApiParticipantsIdUsersGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for uiApiParticipantsIdUsersRemoveDelete without sending the request
     */
    async uiApiParticipantsIdUsersRemoveDeleteRequestOpts(requestParameters: UiApiParticipantsIdUsersRemoveDeleteRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling uiApiParticipantsIdUsersRemoveDelete().'
            );
        }

        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling uiApiParticipantsIdUsersRemoveDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';


        let urlPath = `/ui-api/participants/{id}/users/remove`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        };
    }

    /**
     * Удаление пользователей из участника
     */
    async uiApiParticipantsIdUsersRemoveDeleteRaw(requestParameters: UiApiParticipantsIdUsersRemoveDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.uiApiParticipantsIdUsersRemoveDeleteRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Удаление пользователей из участника
     */
    async uiApiParticipantsIdUsersRemoveDelete(requestParameters: UiApiParticipantsIdUsersRemoveDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.uiApiParticipantsIdUsersRemoveDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for uiApiParticipantsIdUsersUpdatePost without sending the request
     */
    async uiApiParticipantsIdUsersUpdatePostRequestOpts(requestParameters: UiApiParticipantsIdUsersUpdatePostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling uiApiParticipantsIdUsersUpdatePost().'
            );
        }

        if (requestParameters['participantUserUpdateDto'] == null) {
            throw new runtime.RequiredError(
                'participantUserUpdateDto',
                'Required parameter "participantUserUpdateDto" was null or undefined when calling uiApiParticipantsIdUsersUpdatePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';


        let urlPath = `/ui-api/participants/{id}/users/update`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['participantUserUpdateDto']!.map(ParticipantUserUpdateDtoToJSON),
        };
    }

    /**
     * Обновление пользователей участника
     */
    async uiApiParticipantsIdUsersUpdatePostRaw(requestParameters: UiApiParticipantsIdUsersUpdatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.uiApiParticipantsIdUsersUpdatePostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Обновление пользователей участника
     */
    async uiApiParticipantsIdUsersUpdatePost(requestParameters: UiApiParticipantsIdUsersUpdatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.uiApiParticipantsIdUsersUpdatePostRaw(requestParameters, initOverrides);
    }

}
